import axios from "axios";
import { AxiosResponse } from "axios";
import { IToken } from "../types/token";

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const obterUrlBase = (): string => {
    // Se for localhost (desenvolvimento), acessar a API na porta 3019 (V2)
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        const port = 3019;
        return `${window.location.protocol}//${window.location.hostname}:${port}/api`;
    }

    // Se for produção (domínio válido e HTTPS), mantém a regra de subdomínio dinâmico srvbkp
    if (window.location.protocol === "https:") {
        const hostname = window.location.hostname.replace(/^[^.]+/, "srvbkp");
        return `${window.location.protocol}//${hostname}/api`;
    }

    // Fallback padrão
    const port = 3019;
    return `${window.location.protocol}//${window.location.hostname}:${port}/api`;
};

export const urlBase = obterUrlBase();

export const api = axios.create({
    baseURL: urlBase
});

let onSessaoExpiradaCallback: (() => void) | null = null;

export const registrarCallbackSessaoExpirada = (callback: () => void) => {
    onSessaoExpiradaCallback = callback;
};

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            const url = error.config?.url || '';
            // Ignora se for a rota de login ou recuperação inicial de token
            if (!url.includes('token/recuperar') && !url.includes('/token')) {
                if (onSessaoExpiradaCallback) {
                    onSessaoExpiradaCallback();
                }
            }
        }
        return Promise.reject(error);
    }
);

export const buscar = async (url: string, setResposta: (arg0: any) => void) => {
    const resposta = await api.get(url);
    setResposta(resposta.data);
};

export const enviar = async (url: string, dados: any, setResposta: React.Dispatch<React.SetStateAction<never[]>>) => {
    const resposta = await api.post(url, dados);
    setResposta(resposta.data);
};

export interface IApi<T> {
    post(url: string, token: string, dados: any): Promise<AxiosResponse<T, any>>;
    get(url: string, token?: string, config?: any): Promise<AxiosResponse<T, any>>;
}

export class LoginApi {
    static async requestLogin() {
        const response = await apiServer<IToken>().get('token/recuperar');
        const token = response?.data;
        return token;
    }
}


export function apiServer<T>(): IApi<T> {
    return {
        post: async (url: string, token: string, dados: any) => {
            return await api.post<T>(url, dados, {
                headers: {
                    Authorization: "Basic " + token
                }
            });
        },

        get: async (url: string, token?: string, config?: any) => {
            if (token) {
                if (config) {
                    return await api.get<T>(url, {
                        headers: {
                            Authorization: "Basic " + token
                        }
                    });
                } else {
                    return await api.get<T>(url, {
                        headers: {
                            Authorization: "Basic " + token
                        },

                        ...config
                    });
                }
            }

            return await api.get<T>(url);
        }
    };
}
